import { get } from "svelte/store";
import { TrackingLabel } from "../TrackingLabel";
import { keywords } from "../../store/SuggestionStore";
import { SEMANTIC_TRACKING_STRING } from "./higginsLabel";

export class SuggestMethodAction extends TrackingLabel<string> {
  readonly name: string = "san_SuggestMethodAction";
  private _value: string = "semantic";
  private isTracked: boolean = false;

  get value(): string {
    return this._value;
  }

  set value(value: string) {
    this._value = value;
  }

  isTrackable(): boolean {
    if (
      get(keywords).some((keyword) => keyword.target.includes(SEMANTIC_TRACKING_STRING)) &&
      !this.isTracked
    ) {
      return true;
    }
    return false;
  }

  override get data(): { [p: string]: string } {
    const data = super.data;
    if (this.isTrackable()) {
      this.isTracked = true;
    }
    return data;
  }

  /*             */
  setIsTracked(isTracked: boolean) {
    this.isTracked = isTracked;
  }
}

export const tlSuggestMethodAction = new SuggestMethodAction();
